module.exports = __webpack_public_path__ + "static/Daniel-contact-0eceafaefac4525bd10c0b0e17641031.jpeg";